module.exports = __webpack_public_path__ + "img/not_started.ed7b80cd.svg";